/**
 * @fileoverview Reusable Info Modal Component
 *
 * Simple modal for displaying informational content.
 *
 * @version 1.0.0
 */

import React from "react";
import {
  FaTimes,
  FaInfoCircle,
  FaPencilAlt,
  FaEye,
  FaCheck,
} from "react-icons/fa";
import "./InfoModal.css";

const INFO_MESSAGES = {
  selectionsInstructions: (
    <div className="info-message selections">
      <ul>
        <li>
          Click the{" "}
          <strong>
            <FaPencilAlt /> Edit Selections
          </strong>{" "}
          button in each section to make or update your selections.
        </li>
        <li>
          Click the{" "}
          <strong>
            <FaEye />
          </strong>{" "}
          next to a field label to view vendors or options.
        </li>
        <li>Click on an image within a popup to view it in full size.</li>
        <li>You may only edit one section at a time.</li>
        <li> Remember to save your changes before exiting edit mode.</li>
        <li>
          If you need to make a selection that is not available among the given
          options or need to provide additional information about a selection,
          please use the <strong>"Additional Selections / Notes"</strong>{" "}
          section at the end of the overview.
        </li>
      </ul>
      <br />
      <p>
        <b>
          If editing is disabled, your selections deadline has passed and you
          will need to contact your project manager to make changes.
        </b>
      </p>
    </div>
  ),

  cantFindEmail: (
    <div className="info-message email">
      <p>
        <FaCheck /> Please check your spam/junk folder.
      </p>
      <p>
        <FaCheck /> Make sure to mark the email as "not spam" if you find it
        there so it doesn't get filtered out in the future.
      </p>
      <p>
        <FaCheck /> If you still can't find it, try again. You may have
        misspelled your email address.
      </p>
      <div className="row-divider" />
      <p>
        <b>Note:</b> Some corporate email systems may block automated emails
        entirely, so if you don't receive it, please contact your project
        manager directly to have a different email set up with your account.
      </p>
    </div>
  ),

  paintInstructions: (
    <div className="info-message paint">
      <p>Paint selections must be finalized before ordering materials.</p>
      <p>
        If you are unsure about colors, consult your design packet or project
        manager.
      </p>
    </div>
  ),
};

const InfoModal = ({
  isOpen,
  onClose,
  title = "Information",
  message,
  children,
  icon = <FaInfoCircle />,
}) => {
  if (!isOpen) return null;

  return (
    <div className="info-modal-overlay" onClick={onClose}>
      <div className="info-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="info-modal-header">
          <div className="info-modal-header-left">
            {/* Icon */}
            <div className="info-modal-icon">{icon}</div>

            {/* Title */}
            <h3 className="info-modal-title">{title}</h3>
          </div>
          {/* Close Button */}
          <button
            className="info-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </div>
        {/* Content */}
        <div className="info-modal-body">
          {children || INFO_MESSAGES[message]}
        </div>

        {/* Close Button at Bottom 
<div className="info-btn-close-container">
          <button
            className="info-btn-close"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes /> Close
          </button>
        </div>*/}
      </div>
    </div>
  );
};

export default InfoModal;
